import React , { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { selectLabRequestsSubmitting } from '../../../ReduxSlices/LabRequests/labRequests';
import { baseSelectStyles } from '../../shared/selectStyles';
import { selectLabTestTypes } from '../../../ReduxSlices/Admin/labTestServiceSlice';

const LabTestForm = ({
  testType, setTestType,  onSubmit,doctorNotes, setDoctorNotes, role, error
}) => {
  const submitting = useSelector(selectLabRequestsSubmitting);
  const labTestTypes = useSelector(selectLabTestTypes);
  // console.log(labTestTypes);
  
  const handleSubmit = (e) => {
      e.preventDefault();
      if (!testType) {
        alert('Please select a lab test');
        return;
      }
      onSubmit({ lab_test_type_id: testType, doctor_notes: doctorNotes });
    };

  return (
    <form onSubmit={handleSubmit} className="labform space-y-2">
      <h3 className="text-lg font-semibold">Request a lab test</h3>

    <Select
        value={
          testType
            ? labTestTypes
                .map((t) => ({ label: t.name, value: t.id }))
                .find((opt) => opt.value === parseInt(testType))
            : null
        }
        onChange={(option) => setTestType(option?.value || '')}
        options={labTestTypes.map((t) => ({ label: t.name, value: t.id }))}
        placeholder="-- Select Lab Test --"
        isSearchable
        className="w-[250px]"
        styles={baseSelectStyles}
      />
      
      <textarea
          value={doctorNotes}
          onChange={(e) => setDoctorNotes(e.target.value)}
          placeholder="Enter doctor's notes or leave blank"
          className="border p-2 rounded w-full"
      />
    
          <button 
              type="submit" 
              disabled={submitting}
              className="primary"
          >
      {submitting ? 'Submitting...' : 'Submit'}
    </button>
      {error && <p className="error-msg">{error}</p>}
    </form>
  );
};

LabTestForm.propTypes = {
  testType: PropTypes.string.isRequired,
  setTestType: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  doctorNotes: PropTypes.string.isRequired,
  setDoctorNotes: PropTypes.func.isRequired
};

export default LabTestForm;
